module.exports = __webpack_public_path__ + "fc0354f520511cacd71deab089f3c2ff.svg";